/*
 * @Author: showangjing showangjing@didiglobal.com
 * @Date: 2023-02-17 11:07:33
 * @LastEditors: showangjing showangjing@didiglobal.com
 * @LastEditTime: 2023-02-20 11:13:39
 * @FilePath: /fe-eshotel/src/common/track.js
 * @Description: 埋点相关
 */

import raven from '@/common/raven-init/init'
import { trackEvent as webxTrackEvent, query } from '@didi/webx-js';
import { trackEvent as baseTrackEvent } from '@didi/spring-base'
// import store from '@/store';


/**
 * @description omega埋点和天眼事件名称埋点
 * @property {string} eventId - omega埋点id
 * @property {string} eventName - 天眼事件名称埋点
 * @property {object} params - 参数
 * @returns
 */
export function trackEvent(eventId,  eventName = '', params = {}) {
  baseTrackEvent(eventId, eventName, params)
  // try {
  //   if (eventId) {
  //     omegaTrackEvent(eventId, eventName, params);
  //   }
  //   if (eventName && eventName.length) {
  //     ravenTrackEvent(eventName, params)
  //   }
  // } catch(e) {
  //   console.log('上报数据发生了错误', e)
  // }
}

// omega 埋点
export function omegaTrackEvent(eventId, eventName,params = {}) {
  const trackParams = {
    city_id: query()?.city_id,
    abtest: 2, // store.state.common.userGroup,
    ...params
  };
 // 埋点用法
  webxTrackEvent(eventId, eventName, trackParams);
}

// 天眼 埋点
export function ravenTrackEvent(eventName, params = {}) {
  raven.trackEvent?.(eventName, params)
}

//适配层 以后其他报错直接在这个内部修改即可 无需修改代码
export function trackError(eventName, params = {}) {
  ravenTrackError(eventName, params)
}

// 天眼 埋点
/**
 *
 * @param {*} eventName  埋点名称
 * @param {*} params  携带的参数 {source: 'App.onError',error: reason}
 */
export function ravenTrackError(eventName, params = {}) {
  raven.trackError(eventName, params)
}
